<script>
export default {
	data: () => ({
		copyrightDate: new Date().getFullYear(),
		author: 'Arham Natiq',
	}),
};
</script>

<template>
	<p class="font-general-regular text-sm text-gray-400 dark:text-slate-500 text-center">
		&copy; {{ copyrightDate }} &mdash; Crafted by
		<a
			href="https://www.arhamnatiq.com"
			target="_blank"
			rel="noopener noreferrer"
			class="text-gradient font-general-medium hover:opacity-80 transition-opacity duration-200"
		>{{ author }}</a>
	</p>
</template>
